import UpdateClient from './UpdateClient'
export const UpdateClientService = UpdateClient

